import * as React from 'react';
export const PreviewGroupContext = /*#__PURE__*/React.createContext(null);